import { connectedReduxRedirect } from 'redux-auth-wrapper/history4/redirect';
import { replace } from 'connected-react-router';

const AdminAuthenticatedRedirect = connectedReduxRedirect({
    authenticatedSelector: state => state.auth !== null && state.auth.isAdmin,
    authenticatingSelector: state => state.auth.checkingAuth === true,
    redirectAction: replace,
    redirectPath: '/?login=true',
    wrapperDisplayName: 'AdminAuthenticatedRedirect',
});

export default AdminAuthenticatedRedirect;
